// eslint-disable-next-line import/prefer-default-export
export const AssociationAdminLoginSelector = ({ login: { AssociAdminLogin } }) => AssociAdminLogin;
export const AssociationAdminLoginDetailsSelector = ({ login: { AssociAdminLoginDetails } }) => AssociAdminLoginDetails;

